import { useContext } from 'react'
import { useTranslation } from 'next-i18next'
import PropTypes from 'prop-types'

// Context
import { ModalContext } from '../../context/ModalContext'

// Internal components
import Svg from '../Svg/Svg'
import Button from '../Button/Button'

// Utils
import { getIdFromVideoUrl } from '../../utils/video/getIdFromVideoUrl'
import { UserContext } from '../../context/UserContext'

const InstructionHero = (props) => {
  const { videoUrl } = props

  // Context
  const modalContext = useContext(ModalContext)
  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const youtubeId = getIdFromVideoUrl(videoUrl)

  const clickHandler = (event) => {
    if (youtubeId) {
      event.preventDefault()
      const modal = {
        type: 'gallery',
        id: youtubeId,
        youtubeId: youtubeId,
        youtubeTitle: t('INSTRUCTIONHERO_VIDEOTITLE')
      }
      modalContext.openModal(modal)
    }
  }
  return (
    <div className="InstructionHero">
      <div className="InstructionHero-inner">
        <div className="InstructionHero-graphic">
          <div className="InstructionHero-figure">
            <Svg id={'homepage-player'} modifiers={['InstructionHero-playerSvg']} />
          </div>
        </div>
        <div className="InstructionHero-content">
          <h1 className="InstructionHero-title">
            {process.env.NEXT_PUBLIC_THEME === 'knvb' && (
              <>
                {t('INSTRUCTIONHERO_COMPANY').toUpperCase()}
                <span>|</span>
              </>
            )}
            {t('INSTRUCTIONHERO_PROJECT').toUpperCase()}
          </h1>
          <h2 className="InstructionHero-subtitle">{t('INSTRUCTIONHERO_SUBTITLE')}</h2>
          {videoUrl && (
            <a
              className="InstructionHero-link"
              data-youtubeid={youtubeId || false}
              data-youtubetitle={t('INSTRUCTIONHERO_SUBTITLE')}
              href={videoUrl || false}
              onClick={clickHandler}
            >
              <span className="InstructionHero-linkLabel">{t('INSTRUCTIONHERO_VIDEOLABEL')}</span>
              <Svg id={'icon-play'} modifiers={['InstructionHero-linkIcon']} />
            </a>
          )}
          <p className="InstructionHero-description">{t('INSTRUCTIONHERO_DESCRIPTION')}</p>
          <div className="InstructionHero-buttonGroup">
            <Button
              label={t('INSTRUCTIONHERO__BTN_LOGIN')}
              href={'/api/rinus/login'}
              modifiers={['Button--account', 'Button--accountLogin']}
              icon={{ id: 'icon-chevron-right' }}
              image={
                process.env.NEXT_PUBLIC_THEME !== 'sportwide'
                  ? { svgId: `logo-${process.env.NEXT_PUBLIC_THEME}nl` }
                  : null
              }
            />
            <Button
              label={t('INSTRUCTIONHERO__BTN_SIGNUP')}
              href="/api/rinus/register"
              modifiers={['Button--account', 'Button--accountRegister']}
              icon={{ id: 'icon-chevron-right' }}
              image={
                process.env.NEXT_PUBLIC_THEME !== 'sportwide'
                  ? { svgId: `logo-${process.env.NEXT_PUBLIC_THEME}nl` }
                  : null
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

InstructionHero.propTypes = {
  title: PropTypes.object,
  subTitle: PropTypes.string,
  description: PropTypes.string,
  videoUrl: PropTypes.any,
  labelLogin: PropTypes.string,
  labelRegister: PropTypes.string,
  context: PropTypes.any
}

export default InstructionHero
